import {login, logout, getInfo} from '@/api/collection/login'
import {getToken, setToken, removeToken, setRole} from "../../utils/auth";

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    adminInfo: {
      roles: "admin",
      username: "admin",
      icon: "http://gdyueke.oss-cn-guangzhou.aliyuncs.com/image/1694932755818微信图片_20230917142756.jpg",
      menus: [
        {
          title: "营销",
          icon: "sms",
          hidden: true,
          sort: 1
        }
      ]
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo.cellphone, userInfo.password).then(response => {
          const token = response.data
          setToken(token)
          commit('SET_TOKEN', token)
          resolve()
        }).catch(error => {
          reject(error)
        })

      })

    },

    // 获取用户信息
    GetInfo({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo({satoken: getToken()}).then(response => {
          const data = response.data
          commit('SET_ROLES', [data.role])
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          setRole(data.role)
          resolve(data)
        }).catch(error => {
          reject(error)
        })

      })
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout({satoken: getToken()}).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js